import type { PageResponse, Response } from '@/models/api-generated'
import http from '@/services/http'

export interface CustomValueMap {
	[customFieldId: number]: {
		[rowId: number]: string
	}
}

export async function fetchCustomValuesForPage<T>(table: string, response: Response<PageResponse<T>>): Promise<CustomValueMap | undefined> {
	if (response.data?.items.length) {
		const rowIds = response.data?.items.map((x: any) => x.id as number)
		return fetchCustomValues(table, ...rowIds)
	}
	return undefined
}

export async function fetchCustomValues(table: string, ...rowIds: number[]): Promise<CustomValueMap | undefined> {
	const { data } = await http.post<Response<CustomValueMap>>(`api/customFieldValues/${table}`, rowIds)
	return data.data
}

export function useColumnPersistence() {}
